import { defineStore } from "pinia";
import { ref } from "vue";

export const useAppStore = defineStore("app", () => {
  const clientId = ref("");
  const receiverAddress = ref("");
  const contractId = ref("");
  const collectEmail = ref(false);
  const email = ref("");
  const viewNFTText = ref("");
  const setClientId = (clientIdParam: string) => {
    clientId.value = clientIdParam;
  };

  const setReceiverAddress = (address: string) => {
    receiverAddress.value = address;
  };

  const setContractId = (id: string) => {
    contractId.value = id;
  };

  const setCollectEmail = (collectEmailParam: boolean) => {
    collectEmail.value = collectEmailParam;
  };

  const setEmail = (emailParam: string) => {
    email.value = emailParam;
  };

  const setViewNFTText = (text: string) => {
    viewNFTText.value = text;
  };

  return {
    receiverAddress,
    contractId,
    clientId,
    viewNFTText,
    collectEmail,
    email,
    setReceiverAddress,
    setContractId,
    setClientId,
    setViewNFTText,
    setCollectEmail,
    setEmail,
  };
});
